<style>

h3{
  text-align: center;
}

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  /* background-color: rgba(0,0,0,0.4); */
}

.space{
  margin: 20px;
}

</style>

<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>What's your name?</h3>
<div class="space">
  <input type="text" bind:value="{name}" placeholder="Your Name" on:keyup="{check}">
</div>
  
{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let allowSignup = false;
let name = "";
let nameSaved = false;
let nextDisabled = true;


$:{
  if (me) set();
}


function set() {
  name = me.name;
}


function check(e) {
  nameSaved = false;
  try {
    Validate.name(name);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


export const save = async () => {
  if (name != me.name) {
    name = Normalize.name(name);
    me.name = name;
    await profile.updateMe( { updateShare: true } );
  }
}

</script>